import { useRef, useEffect } from "react";

import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import ChevronDownIcon from "@/icons/ChevronDownIcon";
import ActivityHeader from "@/view/ActivityHeader";
import useActivityPanel from "@/view/utils/useActivityPanel";
import { rootCss, iconCss } from "./ActivityPanelTab.style";

const propTypes = {
  fitContent: PropTypes.bool,
  isArticle: PropTypes.bool,
  isStudent: PropTypes.bool,
  onClick: PropTypes.func,
};

const ActivityPanelTab = ({
  fitContent = false,
  isArticle = true,
  isStudent,
  onClick,
}) => {
  const ref = useRef();
  const { isActivityPanelExpanded } = useActivityPanel();

  useEffect(() => {
    ref?.current?.focus();
  }, [isActivityPanelExpanded]);

  return (
    <Button
      onClick={onClick}
      flavor={Button.flavors.incognito}
      __cssFor={{ root: rootCss(!isStudent, fitContent) }}
      ref={ref}
    >
      <ActivityHeader isStudent={isStudent} isArticle={isArticle} />
      <ChevronDownIcon css={iconCss} />
    </Button>
  );
};

ActivityPanelTab.propTypes = propTypes;

export default ActivityPanelTab;
